<h2 mat-dialog-title>
  {{ title }}
</h2>
<mat-dialog-content>
  <p>{{ content }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    mat-flat-button
    color="warn"
    mat-dialog-close
    (click)="onConfirmClick()"
    data-testid="confirm-delete-crm-object-button"
  >
    {{ 'COMMON.ACTION_LABELS.REMOVE' | translate }}
  </button>
</mat-dialog-actions>
